export enum BotTradeStatus {
	Active = 'active',
	Completed = 'completed',
	Cancelled = 'cancelled',
}
